var STRICT_EMAIL_PATTERN = /^(?!.*[>;,]$)(?!.*@[^@\s]+\+\d+$)[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+(?!\d+$)[A-Za-z](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/;

angular.module('userManagementModule', ['ui.bootstrap', 'pascalprecht.translate', 'smart-table', 'angularutilities', 'smarttableutilities'])

	.service('userManagementService', function ($http, $rootScope, storeService, URLS, LEANDNA_EMAIL_SUFFIX) {
		return {
			saveUser: saveUser,
			loadUser: loadUser,
			deleteUser: deleteUser,
			saveFactory: saveFactory,
			deleteFactory: deleteFactory,
			getFactory: getFactory,
			getProfileTypes: getProfileTypes,
			getRoles: getRoles,
			getSuppliers: getSuppliers,
			getCrossSiteSuppliers: getCrossSiteSuppliers,
			getUnassignedFactories: getUnassignedFactories,
			addFactoriesToUser: addFactoriesToUser,
			resetPassword: resetPassword,
			changeState: changeState,
			getUsers: getUsers,
			addUser: addUser,
			getPermissions: getPermissions,
			getMandatoryFilters: getMandatoryFilters,
			deactivateMultipleUsersForFactories: deactivateMultipleUsersForFactories,
			getLastFactoryForUser: getLastFactoryForUser,
			mimicUser: mimicUser,
			getListOfAuthorizedActiveSitesForUsers: getListOfAuthorizedActiveSitesForUsers,
			downgradeCompanyAdmin: downgradeCompanyAdmin,
			mimicSupplierRoleToRegularRole: mimicSupplierRoleToRegularRole,
			getAuthorizedCustomers: getAuthorizedCustomers
		};

		function mimicUser(userId, body) {
			return $http.post('/auth/1/authenticate/ldnasession/switchUser/' + userId)
				.then(function(response) {
					return {
						error: false,
						data: response
					};
				})
				.catch(function(response) {
					return {
						error: true,
						data: response
					};
				});
		}

		function mimicSupplierRoleToRegularRole(body) {
			return $http.post('/auth/1/authenticate/ldnasession/switchSupplierView', body)
				.then(mimicSupplierRoleToRegularRoleComplete)
				.catch(mimicSupplierRoleToRegularRoleFailed);

			function mimicSupplierRoleToRegularRoleComplete(data) {
				return {
					error: false,
					data: data
				};
			}

			function mimicSupplierRoleToRegularRoleFailed(data) {
				return {
					error: true,
					data: data
				};
			}
		}

		function addUser(user) {
			var factoryNdxs = user.factory.ids || globalConfig.factory.id;
			var url = '/api/2/factndx/' + factoryNdxs + '/User';
			return $http.post(url, user)
				.then(addUserComplete)
				.catch(addUserFailed);

			function addUserComplete() {
				return null;
			}

			function addUserFailed(response) {
				if (response.data && response.data.error && response.data.error === 'forbiddenSuperSystemAdmin') {
					$rootScope.$emit('toast', {
						'message': 'This user is not allowed to be a Super System Administrator',
						'success': false
					});
				}
				return response;
			}
		}

		function resetPassword(userNdx, clearUserSession) {
			var url = '/api/2/User/' + userNdx + '/ResetPassword';
			return $http({
				method: 'POST',
				url: url,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				transformRequest: function (obj) {
					var str = [];
					for (var p in obj) {
						str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
					}
					return str.join('&');
				},
				data: {
					'clearUserSession': clearUserSession
				}
			})
				.then(successFn)
				.catch(failureFn);

			function successFn() {
				return true;
			}

			function failureFn() {
				return false;
			}
		}

		function getProfileTypes() {
			var url = URLS.host + URLS.profileTypes;
			return $http.get(url)
				.then(getProfileTypesSuccess)
				.catch(getProfileTypesFailed);

			function getProfileTypesSuccess(response) {
				response.data = _.filter(response.data, function (o) {
					return o.profileType !== 'SuperSystemAdministrator' && o.profileType !== 'CompanyAdministrator';
				});
				return response.data;
			}

			function getProfileTypesFailed(error) {
				return [];
			}
		}

		function getRoles(excludeSupplier) {
			var url = URLS.host + URLS.roles;
			return $http.get(url)
				.then(getRolesSuccess)
				.catch(getRolesFailed);

			function getRolesSuccess(response) {
				var roles = response.data;
				if (!globalConfig.user.userName.toLowerCase().endsWith(LEANDNA_EMAIL_SUFFIX)) {
					roles = _.filter(roles, function (role) {
						return role.roleType !== 'LeanDNAStaff';
					});
				}
				if (excludeSupplier) {
					roles = _.filter(roles, function (role) {
						return role.roleType !== 'Supplier';
					});
				}
				return roles;
			}

			function getRolesFailed(error) {
				return [];
			}
		}

		function getSuppliers(opsFndxList) {
			var url = String.format(URLS.suppliers, opsFndxList.toString());
			url = URLS.host + url;
			return $http.get(url)
				.then(getSuppliersSuccess)
				.catch(getSuppliersFailed);

			function getSuppliersSuccess(response) {
				return response.data;
			}

			function getSuppliersFailed(error) {
				return [];
			}
		}

		function getCrossSiteSuppliers(opsFndxList) {
			var url = String.format('2/factndx/{0}/CrossSiteSuppliers', opsFndxList.toString());
			url = URLS.host + url;
			return $http.get(url)
				.then(getSuppliersSuccess)
				.catch(getSuppliersFailed);

			function getSuppliersSuccess(response) {
				return response.data;
			}

			function getSuppliersFailed(error) {
				return [];
			}
		}

		function saveUser(obj, userNdx, lastModified, objectType) {
			var url = URLS.host + '2/User/' + userNdx;

			if (objectType !== null && objectType == 'customer') {
				var url = URLS.host + '2/companyId/' + globalConfig.customer.id + '/User/' + userNdx;
			}

			return $http.put(url, obj, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			})
				.then(saveUserSuccess)
				.catch(saveUserFailed);

			function saveUserSuccess(response) {
				return response;
			}

			function saveUserFailed(error) {
				return error;
			}
		}

		function loadUser(userNdx) {
			var url = URLS.host + '2/companyId/' + globalConfig.customer.id + '/User/' + userNdx + '/GlobalInfo?showInactive=true';
			return $http.get(url)
				.then(getUserComplete)
				.catch(getUserFailed);

			function getUserComplete(response) {
				return response;
			}

			function getUserFailed(error) {
				return error;
			}
		}

		function getFactory(userNdx, identifierNdx, leanDirFactoryNdx) {
			if (leanDirFactoryNdx) {
				var url = URLS.host + '2/factndx/' + identifierNdx + '/User/' + userNdx + '/FactoryInfo?showInactive=true';
			} else {
				var url = URLS.host + '2/companyId/' + identifierNdx + '/User/' + userNdx + '/CustomerInfo?showInactive=true';
			}
			return $http.get(url)
				.then(getFactoryComplete)
				.catch(getFactoryFailed);

			function getFactoryComplete(response) {
				return response.data;
			}

			function getFactoryFailed(error) {
				return {};
			}
		}

		function deleteUser(userNdx) {
			var url = URLS.host + '2/User?userNdx=' + userNdx;
			return $http.delete(url)
				.then(deleteUserComplete)
				.catch(deleteUserFailed);

			function deleteUserComplete(response) {
				return response;
			}

			function deleteUserFailed(error) {
				return error;
			}
		}

		function saveFactory(factoryObj, userNdx, bulkField, bulkValue) {
			if (factoryObj.leanDirFactoryNdx) {
				var url = URLS.host + '2/factndx/' + factoryObj.leanDirFactoryNdx + '/User/' + userNdx;
			} else {
				var url = URLS.host + '2/companyId/' + factoryObj.customerNdx + '/User/' + userNdx;
			}
			if (bulkField != null && bulkValue != null) {
				url += '?bulkField=' + encodeURIComponent(bulkField) + '&bulkValue=' + encodeURIComponent(bulkValue);
			}
			return $http.put(url, factoryObj, {
				headers: {
					'If-Unmodified-Since': new Date(parseInt(factoryObj.dateModified)).toUTCString()
				}
			})
				.then(saveFactoryComplete)
				.catch(saveFactoryFailed);

			function saveFactoryComplete(response) {
				return response;
			}

			function saveFactoryFailed(error) {
				return error;
			}
		}

		function deleteFactory(userNdx, factoryNdxs, customerNdxs, assignToUserNdx) {
			var url = URLS.host + '2/factndx/' + factoryNdxs.join(',') + '/User/' + userNdx + '/AssignToUser/' + assignToUserNdx;
			return $http.put(url, customerNdxs.join(','))
				.then(deleteFactoryComplete)
				.catch(deleteFactoryFailed);

			function deleteFactoryComplete(response) {
				return response;
			}

			function deleteFactoryFailed(error) {
				return error;
			}
		}

		function getUnassignedFactories(userNdx, forCustomers) {
			if (forCustomers) {
				var url = URLS.host + '2/User/' + userNdx + '/UnassignedCustomers';
			} else {
				var url = URLS.host + '2/User/' + userNdx + '/UnassignedFactories';
			}
			return $http.get(url)
				.then(getUnassignedFactoriesComplete)
				.catch(getUnassignedFactoriesFailed);

			function getUnassignedFactoriesComplete(response) {
				return response.data;
			}

			function getUnassignedFactoriesFailed(error) {
				return [];
			}
		}

		function addFactoriesToUser(userNdx, ndxList, objList, forCustomers) {
			if (forCustomers) {
				var url = URLS.host + '2/User/' + userNdx + '/Customers/' + ndxList;
			} else {
				var url = URLS.host + '2/User/' + userNdx + '/Factories/' + ndxList;
			}
			return $http.post(url, objList)
				.then(addFactoriesToUserSuccess)
				.catch(addFactoriesToUserFailed);

			function addFactoriesToUserSuccess(response) {
				return response;
			}

			function addFactoriesToUserFailed(error) {
				return error;
			}
		}

		function changeState(userNdx, factoryNdxs, state) {
			var url = URLS.host + '2/User/' + userNdx + '/Factories/' + factoryNdxs + '/State/' + state;
			return $http.put(url)
				.then(changeStateSuccess)
				.catch(changeStateFailed);

			function changeStateSuccess(response) {
				storeService.dispatch(storeService.actionCreators.clearUserEngagementKpiTooltips());
				return response;
			}

			function changeStateFailed(error) {
				return error;
			}
		}

		function getUsers(factoryNdxs) {
			var url = URLS.host + '2/Dimensions/factndx/' + factoryNdxs.join(',') + '/UsersInAllSites';
			if ($rootScope.authz.isLeanDNAAdmin()) {
				url += '?includeHiddenFromDropdown=true';
			}
			return $http.get(url)
				.then(getUsersComplete)
				.catch(getUsersFailed);

			function getUsersComplete(response) {
				return response;
			}

			function getUsersFailed(error) {
				return error;
			}
		}

		function getPermissions(factoryNdx) {
			var url = URLS.host + '2/Dimensions/factndx/' + factoryNdx + '/Permissions';
			return $http.get(url)
				.then(getPermissionsComplete)
				.catch(getPermissionsFailed);

			function getPermissionsComplete(response) {
				return response.data;
			}

			function getPermissionsFailed(error) {
				return [];
			}
		}

		function getMandatoryFilters(factoryNdx) {
			var url = URLS.host + '2/Dimensions/factndx/' + factoryNdx + '/MandatoryFilters';
			return $http.get(url)
				.then(getMandatoryFiltersComplete)
				.catch(getMandatoryFiltersFailed);

			function getMandatoryFiltersComplete(response) {
				return response.data;
			}

			function getMandatoryFiltersFailed(error) {
				return [];
			}
		}

		function deactivateMultipleUsersForFactories(userList, factoryList) {
			var url = URLS.host + '2/User/Factories/' + factoryList + '/State/inactive';
			return $http({
				method: 'POST',
				url: url,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				transformRequest: function (obj) {
					var str = [];
					for (var p in obj) {
						str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
					}
					return str.join('&');
				},
				data: {
					'users': userList
				}
			})
				.then(deactivateMultipleUsersForFactoriesComplete)
				.catch(deactivateMultipleUsersForFactoriesFailed);

			function deactivateMultipleUsersForFactoriesComplete(response) {
				return response;
			}

			function deactivateMultipleUsersForFactoriesFailed(error) {
				return error;
			}
		}

		function getLastFactoryForUser(userNdx) {
			var url = URLS.host + '2/User/' + userNdx + '/LastFactory';
			return $http.get(url)
				.then(getLastFactoryForUserComplete)
				.catch(getLastFactoryForUserFailed);

			function getLastFactoryForUserComplete(response) {
				return response.data;
			}

			function getLastFactoryForUserFailed(error) {
				return [];
			}
		}

		function getListOfAuthorizedActiveSitesForUsers(userNdxs) {
			var url = URLS.host + '2/Users/AuthorizedSites?userNdxs=' + userNdxs;
			return $http.get(url)
				.then(getListOfAuthorizedActiveSitesForUsersComplete)
				.catch(getListOfAuthorizedActiveSitesForUsersFailed);

			function getListOfAuthorizedActiveSitesForUsersComplete(response) {
				return response.data;
			}

			function getListOfAuthorizedActiveSitesForUsersFailed(error) {
				return [];
			}
		}

		function downgradeCompanyAdmin(userNdx, customerNdxList) {
			var url = URLS.host + '2/companyId/' + customerNdxList + '/User/' + userNdx + '/downgradeCompanyAdmin';
			return $http.put(url)
				.then(downgradeCompanyAdminSuccess)
				.catch(downgradeCompanyAdminFailed);

			function downgradeCompanyAdminSuccess(response) {
				return response;
			}

			function downgradeCompanyAdminFailed(error) {
				return error;
			}
		}

		function getAuthorizedCustomers(userNdx, isSupplier) {
			var url = URLS.host + '2/Dimensions/CustomersForUser/?forEmailNotifications=true&supplierOnly=' + isSupplier + '&forUser=' + userNdx;
			return $http.get(url)
				.then(getAuthorizedCustomersComplete)
				.catch(getAuthorizedCustomersFailed);

			function getAuthorizedCustomersComplete(response) {
				return response;
			}

			function getAuthorizedCustomersFailed(error) {
				return error;
			}
		}
	})

	.controller('userFormCtrl', function ($scope, $window, $timeout, $uibModal, $compile, $rootScope, $location, $http, siteService, userManagementService, URLS, LEANDNA_EMAIL_SUFFIX, $experiments) {
		$scope.showNotification = false;
		$scope.myAccountView = ($location.path() && $location.path() === '/account/edit');
		$scope.hasSupplierRole = siteService.hasRolesSupplier();
		$scope.currentUserProfileRank = siteService.getUserMaxProfileRank();
		$scope.dropdownLists = {};
		$scope.user = {};
		$scope.customer = {};
		$scope.editing = {};
		$scope.displayTabIndex = 0;
		$scope.reactivationRequestSubmitted = false;
		$scope.emailReactivationTooltip = 'Email was undeliverable to this address and it has been deactivated.';
		$scope.emailPattern = STRICT_EMAIL_PATTERN;
		$scope.showMimicUser = false;
		$scope.linkBack = function() {
			return 'app.company-setup.manage-users';
		};

		var userNdx;
		var userLastModified;
		var variables = {
			'firstName': {
				'label': 'First Name',
				'value': 'firstName',
				'display': 'firstName',
				'type': 'user'
			},
			'lastName': {
				'label': 'Last Name',
				'value': 'lastName',
				'display': 'lastName',
				'type': 'user'
			},
			'emailAddress': {
				'label': 'Email Address',
				'value': 'emailAddress',
				'display': 'emailAddress',
				'type': 'user'
			},
			'roleType': {
				'label': 'Role',
				'value': 'roleType',
				'display': 'name',
				'type': 'customer'
			},
			'canCreateSupplierUser': {
				'label': 'Can create supplier user',
				'value': 'canCreateSupplierUser',
				'display': 'canCreateSupplierUser',
				'type': 'customer'
			},
			'canAccessIOP': {
				'label': 'Inventory optimization access',
				'value': 'canAccessIOP',
				'display': 'canAccessIOP',
				'type': 'customer'
			},
			'canAccessKei': {
				'label': 'Kei AI access',
				'value': 'canAccessKei',
				'display': 'canAccessKei',
				'type': 'customer'
			}
		};

		$scope.toggleActivation = function () {
			var currentVal = $scope.user.isComputerActivationEnabled;
			currentVal = !currentVal;
			var oldVal = !currentVal;
			var obj = $scope.user;
			obj.isComputerActivationEnabled = currentVal;
			userManagementService.saveUser(obj, userNdx, userLastModified).then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					$scope.user.isComputerActivationEnabled = currentVal;
					$rootScope.$emit('toast', {
						'message': 'Computer Activation has been saved successfully',
						'success': true
					});
					loadUser();
				} else if (response && response.status == 412) {
					$scope.user.isComputerActivationEnabled = oldVal;
					$rootScope.$emit('toast', {
						'message': 'This user has been updated since you loaded the page, please refresh the page',
						'success': false
					});
				} else {
					$scope.user.isComputerActivationEnabled = oldVal;
					$rootScope.$emit('toast', {
						'message': 'Unexpected server error',
						'success': false
					});
				}
			});
		};

		function setPageProperties() {
			if ($scope.myAccountView) {
				$scope.reportTitle = 'My Account';
				$location.search('userNdx', null);
				$location.path('/account/edit').replace();
			} else {
				$scope.reportTitle = 'Edit User';
				$scope.showBreadCrumb = true;
			}
		}

		$scope.toggleSingleSignOn = function () {
			var currentVal = $scope.user.isSingleSignOn;
			currentVal = !currentVal;
			var oldVal = !currentVal;
			var obj = $scope.user;
			obj.isSingleSignOn = currentVal;
			userManagementService.saveUser(obj, userNdx, userLastModified).then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					$scope.user.isSingleSignOn = currentVal;
					$rootScope.$emit('toast', {
						'message': 'Single Sign On has been saved successfully',
						'success': true
					});
					loadUser();
					$rootScope.$broadcast('reloadTable');
				} else if (response && response.status == 412) {
					$scope.user.isSingleSignOn = oldVal;
					errorMessage = 'This user has been updated since you loaded the page, please refresh the page';
					if (response.data && response.data.error) {
						errorMessage = response.data.error;
					}
					$rootScope.$emit('toast', {
						'message': errorMessage,
						'success': false
					});
				} else {
					$scope.user.isSingleSignOn = oldVal;
					$rootScope.$emit('toast', {
						'message': 'Unexpected server error',
						'success': false
					});
				}
			});
		};

		$scope.toggleCanAccessIOP = function () {
			var currentVal = $scope.customer.canAccessIOP;
			currentVal = !currentVal;

			change();

			function change() {
				var oldVal = !currentVal;

				var obj = $scope.customer;
				obj.canAccessIOP = currentVal;

				userManagementService.saveUser(obj, userNdx, userLastModified, 'customer').then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$scope.customer.canAccessIOP = currentVal;
						$rootScope.$emit('toast', {
							'message': 'Can access IOP has been saved successfully',
							'success': true
						});
						loadUser();
						$rootScope.$broadcast('reloadTable');
					} else if (response && response.status == 412) {
						$scope.customer.canAccessIOP = oldVal;
						$rootScope.$emit('toast', {
							'message': 'This user has been updated since you loaded the page, please refresh the page',
							'success': false
						});
					} else {
						$scope.customer.canAccessIOP = oldVal;
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
				});
			}
		};

		$scope.toggleCanAccessKei = function () {
			var currentVal = $scope.customer.canAccessKei;
			currentVal = !currentVal;

			change();

			function change() {
				var oldVal = !currentVal;

				var obj = $scope.customer;
				obj.canAccessKei = currentVal;

				userManagementService.saveUser(obj, userNdx, userLastModified, 'customer').then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$scope.customer.canAccessKei = currentVal;
						$rootScope.$emit('toast', {
							'message': 'Can access Kei AI has been saved successfully',
							'success': true
						});
						loadUser();
						$rootScope.$broadcast('reloadTable');
					} else if (response && response.status == 412) {
						$scope.customer.canAccessKei = oldVal;
						$rootScope.$emit('toast', {
							'message': 'This user has been updated since you loaded the page, please refresh the page',
							'success': false
						});
					} else {
						$scope.customer.canAccessKei = oldVal;
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
				});
			}
		};

		$scope.toggleCanCreateSupplierUser = function () {
			var currentVal = $scope.customer.canCreateSupplierUser;
			currentVal = !currentVal;

			change();

			function change() {
				var oldVal = !currentVal;

				var obj = $scope.customer;
				obj.canCreateSupplierUser = currentVal;

				userManagementService.saveUser(obj, userNdx, userLastModified, 'customer').then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$scope.customer.canCreateSupplierUser = currentVal;
						$rootScope.$emit('toast', {
							'message': 'Can create supplier user has been saved successfully',
							'success': true
						});
						loadUser();
						$rootScope.$broadcast('reloadTable');
					} else if (response && response.status == 412) {
						$scope.customer.canCreateSupplierUser = oldVal;
						$rootScope.$emit('toast', {
							'message': 'This user has been updated since you loaded the page, please refresh the page',
							'success': false
						});
					} else {
						$scope.customer.canCreateSupplierUser = oldVal;
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
				});
			}
		};

		$scope.toggleLimitToLeanProjects = function () {
			var currentVal = $scope.user.isLeanOnly;
			currentVal = !currentVal;

			change();

			function change() {
				var oldVal = !currentVal;

				var obj = $scope.customer;
				obj.isLeanOnly = currentVal;

				userManagementService.saveUser(obj, userNdx, userLastModified, 'customer').then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$scope.user.isLeanOnly = currentVal;
						$rootScope.$emit('toast', {
							'message': 'Limit to lean projects has been saved successfully',
							'success': true
						});
						loadUser();
						$rootScope.$broadcast('reloadTable');
					} else if (response && response.status == 412) {
						$scope.user.isLeanOnly = oldVal;
						$rootScope.$emit('toast', {
							'message': 'This user has been updated since you loaded the page, please refresh the page',
							'success': false
						});
					} else {
						$scope.user.isLeanOnly = oldVal;
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
				});
			}
		};


		$scope.toggleCanUseDataApi = function () {
			var currentVal = $scope.user.canUseDataAPI;
			currentVal = !currentVal;

			if (!currentVal) {
				var confirmScope = $scope.$new();
				confirmScope.prefixText = 'Disabling Data API will result in the deletion of all API keys for this user. This action cannot be undone. ';
				confirmScope.additionalText = 'disable Data API and delete all API keys for this user';
				confirmScope.buttonText = 'Yes';
				var opts = {
					scope: confirmScope,
					templateUrl: '/application/f/core/confirm.html'
				};

				var instance = $uibModal.open(opts);
				confirmScope.closeDialog = function () {
					instance.close();
					confirmScope.$destroy();
				};

				confirmScope.yes = function () {
					instance.close();
					confirmScope.$destroy();
					change();
				};
			} else {
				change();
			}

			function change() {
				var oldVal = !currentVal;

				var obj = $scope.user;
				obj.canUseDataAPI = currentVal;

				userManagementService.saveUser(obj, userNdx, userLastModified).then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$scope.user.canUseDataAPI = currentVal;
						$rootScope.$emit('toast', {
							'message': 'Can Use Data API has been saved successfully',
							'success': true
						});
						loadUser();
						// The "Data API" tab index jump to first one when this tab gets deleted
						if($scope.displayTabIndex === 3) {
							$scope.selectTab(0);
						}
					} else if (response && response.status == 412) {
						$scope.user.canUseDataAPI = oldVal;
						$rootScope.$emit('toast', {
							'message': 'This user has been updated since you loaded the page, please refresh the page',
							'success': false
						});
					} else {
						$scope.user.canUseDataAPI = oldVal;
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
				});
			}
		};

		$scope.toggleIsUSPerson = function () {
			var currentVal = $scope.user.isUSPerson;
			currentVal = !currentVal;
			var oldVal = !currentVal;

			var obj = $scope.user;
			obj.isUSPerson = currentVal;

			userManagementService.saveUser(obj, userNdx, userLastModified).then(function (response) {
				if (response && response.status && response.status >= 200 && response.status < 400) {
					$scope.user.isUSPerson = currentVal;
					$rootScope.$emit('toast', {
						'message': 'US Person access has been changed successfully',
						'success': true
					});
					loadUser();
					location.reload();
				} else if (response && response.status == 412) {
					$scope.user.isUSPerson = oldVal;
					$rootScope.$emit('toast', {
						'message': 'This user has been updated since you loaded the page, please refresh the page',
						'success': false
					});
				} else {
					$scope.user.isUSPerson = oldVal;
					$rootScope.$emit('toast', {
						'message': 'Unexpected server error',
						'success': false
					});
				}
			});
		};

		$scope.toggleisSuperSystemAdministrator = function () {
			var currentVal = $scope.user.isSuperSystemAdministrator;
			currentVal = !currentVal;

			if (!currentVal) {
				var confirmScope = $scope.$new();
				confirmScope.prefixText = 'Disabling Super System Administrator access will delete all virtual factory profiles for this user. Non-virtual profiles will be downgraded to System Administrator access. ';
				confirmScope.additionalText = ' disable super system administrator access for this user';
				confirmScope.buttonText = 'Yes';
				var opts = {
					scope: confirmScope,
					templateUrl: '/application/f/core/confirm.html'
				};

				var instance = $uibModal.open(opts);
				confirmScope.closeDialog = function () {
					instance.close();
					confirmScope.$destroy();
				};

				confirmScope.yes = function () {
					instance.close();
					confirmScope.$destroy();
					change();
				};
			} else {
				var confirmScope = $scope.$new();
				confirmScope.prefixText = 'Enabling Super System Administrator access will add a virtual super system administrator profile to all additional factories. Existing factory profiles will be upgraded to super system administrator access. ';
				confirmScope.additionalText = ' enable super system administrator access for this user';
				confirmScope.buttonText = 'Yes';
				var opts = {
					scope: confirmScope,
					templateUrl: '/application/f/core/confirm.html'
				};

				var instance = $uibModal.open(opts);
				confirmScope.closeDialog = function () {
					instance.close();
					confirmScope.$destroy();
				};

				confirmScope.yes = function () {
					instance.close();
					confirmScope.$destroy();
					change();
				};
			}
			function change() {
				var oldVal = !currentVal;

				var obj = $scope.user;
				obj.isSuperSystemAdministrator = currentVal;

				userManagementService.saveUser(obj, userNdx, userLastModified).then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$scope.user.isSuperSystemAdministrator = currentVal;
						$rootScope.$emit('toast', {
							'message': 'Super System Administrator access has been saved successfully',
							'success': true
						});
						loadUser();
						location.reload();
					} else if (response && response.status == 412) {
						$scope.user.isSuperSystemAdministrator = oldVal;
						$rootScope.$emit('toast', {
							'message': 'This user has been updated since you loaded the page, please refresh the page',
							'success': false
						});
					} else {
						$scope.user.isSuperSystemAdministrator = oldVal;
						$rootScope.$emit('toast', {
							'message': 'Unexpected server error',
							'success': false
						});
					}
				});
			}
		};

		function resetPasswordConfirmed(clearUserSessions) {
			userManagementService.resetPassword(userNdx, clearUserSessions)
				.then(function (success) {
					if (success) {
						$rootScope.$emit('toast', {
							'message': 'Password has been reset',
							'success': true
						});
					} else {
						$rootScope.$emit('toast', {
							'message': 'Error occurred, could not reset password',
							'success': false
						});
					}
				});
		}

		$scope.resetPassword = function () {
			var confirmScope = $scope.$new();
			confirmScope.username = $scope.user.username;
			confirmScope.buttonText = 'Yes';
			confirmScope.addCheckbox = true;
			confirmScope.form = {
				checkBoxValue: false
			};

			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/setup/reset_password_confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				resetPasswordConfirmed(confirmScope.form.checkBoxValue);
				instance.close();
				confirmScope.$destroy();
			};
		};

		$scope.mimicUser = function () {
			var mimicScope = $scope.$new();
			mimicScope.selected = {};
			mimicScope.additionalText = 'mimic this user session';
			mimicScope.buttonText = 'Mimic';
			mimicScope.yes = function () {
				userManagementService.loadUser(userNdx).then(function (response) {
					if (response && response.status && response.status === 404) {
						location.href = '/application/f/home.html#/setup/manage-users';
					}
					if (response && response.data) {
						if (response.data.base.activatedFlag) {
							userManagementService.mimicUser(userNdx).then(function (result) {
								mimicScope.closeDialog();
								if (result.error) {
									if (result.data.status == 403 && result.data.data.error == 'mimickedUserHasMorePermissions') {
										$rootScope.$emit('toast', {
											'message': 'The user you are mimicking has access to sites you are not authorized for, or has more admin permissions',
											'success': false
										});
									} else {
										$rootScope.$emit('toast', {
											'message': 'Error occurred, could not mimic user session',
											'success': false
										});
									}
									return;
								}
								var path = undefined;
								if (result.data.data.homePage) {
									path = encodeURIComponent(result.data.data.homePage);
								}
								location.href = '/application/factory-switch.html?p=' + path;
							});
						} else {
							$scope.user.activatedFlag = response.data.base.activatedFlag;
							$rootScope.$emit('toast', {
								'message': 'Error occurred, User is not active. This user has been updated since you loaded the page, please refresh the page',
								'success': false
							});
							mimicScope.closeDialog();
						}
					}
				});

			};

			var opts = {
				scope: mimicScope,
				templateUrl: '/application/f/core/' + 'confirm.html'
			};

			var instance = $uibModal.open(opts);
			mimicScope.closeDialog = function () {
				instance.close();
				mimicScope.$destroy();
			};
		};

		$scope.cancelEdit = function () {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			$scope.inlineActive = false;
		};

		$scope.saveEdit = function (variableName) {
			var content = strip($scope.editing[variableName]).trim();
			var objectType = variables[variableName].type;
			var value = $scope[objectType];
			var oldVal = $scope[objectType][variableName];
			value[variableName] = content;
			if (variableName === 'emailAddress') {
				value.username = value.emailAddress;
			}
			if (content) {
				userManagementService.saveUser(value, userNdx, userLastModified, objectType)
					.then(function (response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$scope[objectType][variableName] = content;
							$rootScope.$emit('toast', {
								'message': variables[variableName].label + ' has been saved successfully',
								'success': true
							});
							loadUser();
							$rootScope.$broadcast('reloadTable');
						} else if (response && response.status == 412) {
							$scope[objectType][variableName] = oldVal;
							$scope.user.username = $scope.user.emailAddress;
							$rootScope.$emit('toast', {
								'message': 'This user has been updated since you loaded the page, please refresh the page',
								'success': false
							});
						} else if (response && response.status == 409) {
							$scope[objectType][variableName] = oldVal;
							$scope.user.username = $scope.user.emailAddress;
							$rootScope.$emit('toast', {
								'message': 'A user with email address ' + content + ' already exists.',
								'success': false
							});
						} else {
							$scope[objectType][variableName] = oldVal;
							$scope.user.username = $scope.user.emailAddress;
							$rootScope.$emit('toast', {
								'message': 'Unexpected server error',
								'success': false
							});
						}
					});
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			$scope.inlineActive = false;
		};

		$scope.startEdit = function (variableName) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var objectType = variables[variableName].type;
			var cell = jQuery('#' + variableName + 'Value');
			var pos = cell.offset();
			var editTemplate = getTemplate(pos, variableName);
			$scope.editing[variableName] = $scope[objectType][variableName];
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					$scope.saveEdit(variableName);
				} else if (code == 27) {
					$scope.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			$scope.inlineActive = true;
		};

		$scope.startEditDropdown = function (variableName) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var objectType = variables[variableName].type;
			var cell = jQuery('#' + variableName + 'Value');
			var pos = cell.offset();
			var editTemplate = getListTemplate(pos, variableName);
			$scope.editing[variableName] = $scope[objectType][variableName];
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('.embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function (event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					$scope.saveEdit(variableName);
				} else if (code == 27) {
					$scope.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			$scope.inlineActive = true;
		};

		$scope.selectTab = function (index) {
			$scope.displayTabIndex = index;
		};

		$scope.clearBounceStatus = function () {
			var toastTime = 10000;
			$http.post(URLS.host + URLS.emailNotification + '/ClearBounce/' + $scope.user.emailAddress)
				.then(clearBounceStatusSuccess)
				.catch(clearBounceStatusFailure);

			function clearBounceStatusSuccess(response) {
				$scope.user.wasBounced = false;
				$rootScope.$emit('toast', {
					'message': 'Email reactivated. LeanDNA emails will be sent to this user again.',
					'success': true,
					'time': toastTime
				});
			}

			function clearBounceStatusFailure(error) {
				$rootScope.$emit('toast', {
					'message': 'Unable to reactivate email.',
					'success': false,
					'time': toastTime
				});
			}
		};

		function validEmailAddress() {
			if ($scope.editing.emailAddress) {
				if ($scope.emailPattern.test($scope.editing.emailAddress)
					&& (
						($scope.editing.emailAddress.toLowerCase().endsWith(LEANDNA_EMAIL_SUFFIX) && $scope.user.emailAddress.toLowerCase().endsWith(LEANDNA_EMAIL_SUFFIX))
						|| (!$scope.editing.emailAddress.toLowerCase().endsWith(LEANDNA_EMAIL_SUFFIX) && !$scope.user.emailAddress.toLowerCase().endsWith(LEANDNA_EMAIL_SUFFIX))
					)
				) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		}

		$scope.$watch(validEmailAddress, function (isValidEmail) {
			$scope.isValidEmail = isValidEmail;
		});

		function getTemplate(position, variableName) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			var label = variables[variableName].label;
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var disabled = '"!editing.' + variableName;
			var pattern = '';
			if (variableName === 'emailAddress') {
				disabled += ' || !isValidEmail';
				pattern += 'ng-pattern = "emailPattern"';
			}
			disabled += '"';
			var editTemplate = '<div class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">Change ' + label + '</div>' +
				'<div class="input-holder-with-clear">' +
				'<input class="inlineEditInput with-clear" ng-model="editing.' + variableName + '"' + pattern + ' />' +
				'<span class="input-clear" ng-show="editing.' + variableName + ' && editing.' + variableName + '.length" ng-click="editing.' + variableName + ' = \'\'"><i class="fa fa-times"></i></span>' +
				'</div>' +
				'<div class="inlineEditButtons"><button class="button flat" ng-click="cancelEdit(' + "'" + variableName + "'" + ')">Cancel</button>' +
				'<button class="button flat colored" ng-disabled=' + disabled + ' ng-click="saveEdit(' + "'" + variableName + "'" + ')">Save</button></div></div>';
			return editTemplate;
		}

		function getListTemplate(position, variableName) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			var label = variables[variableName].label;
			var display = variables[variableName].display;
			var value = variables[variableName].value;
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var groupby = '';
			if (variableName === 'roleType') {
				groupby = 'roleGroup';
			}
			var filter = 'filter: {' + display + ': $select.search}';
			var editTemplate = '<div class="inlineEditDiv textEdit ' + '" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">Change ' + label + '</div>' +
				'<ui-select append-to-body="true" theme="bootstrap" ng-model="editing.' + variableName + '">' +
				'<ui-select-match placeholder="{{' + "'Select " + label + "...'" + ' | translate}}">' +
				'{{$select.selected.' + display + '}}' +
				'</ui-select-match>' +
				'<ui-select-choices group-by="' + "'" + groupby + "'" + '" repeat="item.' + value + ' as item in dropdownLists.' + variableName + ' | ' + filter + '">' +
				'{{item.' + display + '}}' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="cancelEdit()">Cancel</button>' +
				'<button class="button flat colored" ng-disabled="!editing.' + variableName + ' && !(editing.' + variableName + ' == false)" ng-click="saveEdit(' + "'" + variableName + "'" + ')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function loadUser() {
			userManagementService.loadUser(userNdx).then(function (response) {
				if (response && response.status && response.status === 404) {
					location.href = '/application/f/home.html#/setup/manage-users';
				}
				if (response && response.data) {
					var headers = response.headers();
					if (headers) {
						userLastModified = headers['last-modified'];
					}
					
					var data = response.data;

					$scope.user = data.base;
					$scope.customer = data.customer;
					if ($scope.customer === null) {
						$scope.customer = { 'isCustomerAdministrator': $scope.user.isSuperSystemAdministrator };
					}
					$scope.isEditingSelf = $scope.user.username === globalConfig.user.userName;
					$scope.isSuperSystemAdministrator = data.base.isSuperSystemAdministrator;
					$scope.canUseDataAPI = data.base.canUseDataAPI;
					$scope.isLeanDnaEmail = data.base.emailAddress.toLowerCase().endsWith(LEANDNA_EMAIL_SUFFIX);
					$scope.showMimicUser = $scope.currentUserProfileRank >= $scope.user.profileRank;
				}
			});
		};

		$scope.canEditFieldsInUserForm = function () {
			if ($rootScope.authz.isSuperAdmin()) {
				return true;
			}
			if ($scope.user.isSuperSystemAdministrator) {
				return false;
			}
			if ($rootScope.authz.isCustomerAdmin()) {
				return true;
			}
			if ($scope.customer.isCustomerAdministrator) {
				return false;
			}
			if ($rootScope.authz.isAdmin()) {
				return true;
			}
			return false;
		};

		$scope.canEditIOPFieldInUserForm = function () {
			if ($rootScope.authz.isSuperAdmin()) {
				return true;
			}
			if ($scope.user.isSuperSystemAdministrator) {
				return false;
			}
			if ($rootScope.authz.isCustomerAdmin()) {
				return true;
			}
			if ($scope.customer.isCustomerAdministrator) {
				return false;
			}
			if ($rootScope.authz.isAdmin()) {
				return false;
			}
			return false;
		};

		$scope.canEditKeiAIFieldInUserForm = function () {
			if ($scope.user.username && $scope.user.username.toLowerCase().endsWith(LEANDNA_EMAIL_SUFFIX)) {
				return false;
			}
			if ($rootScope.authz.isSuperAdmin()) {
				return true;
			}
			if ($rootScope.authz.isLeanDNACustomerAdmin()) {
				return true;
			}
			return false;
		};

		$scope.hideFieldsInUserForm = function () {
			return $rootScope.authz.isSuperAdmin() ||
				($rootScope.authz.isCustomerAdmin() && $scope.customer.isCustomerAdministrator);
		};

		$scope.hideIOPFieldInUserForm = function () {
			if ($scope.customer.roleType === 'Supplier') {
				return true;
			}
			
			var isUserInCurrentCustomer = false;
			if ($scope.authorizedCustomers) {
				isUserInCurrentCustomer = $scope.authorizedCustomers.some(function(customer) {
					return customer.ndx === globalConfig.customer.id;
				});
			}
			return !isUserInCurrentCustomer;
		};

		$scope.hideKeiFieldInUserForm = function () {
			if ($scope.customer.roleType === 'Supplier') {
				return true;
			}
			
			var isUserInCurrentCustomer = false;
			if ($scope.authorizedCustomers) {
				isUserInCurrentCustomer = $scope.authorizedCustomers.some(function(customer) {
					return customer.ndx === globalConfig.customer.id;
				});
			}
			return !$experiments.isEnabled('kei-ai') || !isUserInCurrentCustomer;
		};

		function init() {
			var incomingQParam = $location.search();
			var isSupplier = globalConfig.user.role === 'Supplier';
			if (incomingQParam) {
				userNdx = incomingQParam.userNdx;
				$scope.myAccountView = $scope.myAccountView || (userNdx == globalConfig.user.id && !$rootScope.authz.isSuperOrCustomerAdmin());
				setPageProperties();
			}
			// No query param - assume this is a request to show the user their own account
			if (!userNdx)
				userNdx = globalConfig.user.id;
			loadUser();
			// Roles endpoint requires admin READ; skip on My Account for non-admins
			// so restricted users are not redirected to #/unauthorized.
			if (!isSupplier && $rootScope.authz.isAdmin()) {
				userManagementService.getRoles().then(function initRoles(roles) {
					$scope.dropdownLists.roleType = _.filter(roles, function (role) {
						return role.roleType !== 'Supplier';
					});
				});
			}

			userManagementService.getAuthorizedCustomers(userNdx, isSupplier).then(function initNotifications(authorizedCustomers) {
				$scope.authorizedCustomers = authorizedCustomers.data;
				$scope.showNotification =
					authorizedCustomers != null &&
					authorizedCustomers.data &&
					authorizedCustomers.data.length > 0 &&
					$rootScope.authorize(['supplyChain', 'workbench']);
			});
		}

		init();
	})

	.controller('newUserCtrl', function ($scope, $uibModal, $rootScope, $timeout, $filter, $translate, $experiments, site_url, userManagementService, navigationService,
		siteService, LEANDNA_EMAIL_SUFFIX) {
		$scope.title = 'New User';

		$scope.submit = submit;
		$scope.cancel = cancel;
		$scope.validForm = validForm;
		$scope.clearToast = clearToast;
		$scope.roleSelected = roleSelected;
		$scope.clearErrorMessage = clearErrorMessage;
		$scope.translateRoleGroup = function(item) {
			return $translate.instant(item.roleGroup);
		};
		$scope.displayHideFromDropdown = globalConfig.user.userName.toLowerCase().endsWith(LEANDNA_EMAIL_SUFFIX);
		$scope.emailPattern = STRICT_EMAIL_PATTERN;

		$scope.allowOptions = [{
			name: 'Yes',
			value: true
		},
		{
			name: 'No',
			value: false
		}
		];
		$scope.computerActivationOptions = [{
			name: 'Enabled',
			value: true
		},
		{
			name: 'Disabled',
			value: false
		}
		];
		$scope.emailTypes = [{
			name: 'Receive emails once a day',
			value: 'Daily'
		},
		{
			name: 'Receive emails immediately',
			value: 'Immediate'
		},
		{
			name: 'Unsubscribe',
			value: 'Off'
		}
		];
		$scope.roles = [];
		$scope.privileges = [];
		$scope.suppliers = [];
		$scope.permissions = [];
		$scope.mandatoryFilters = [];
		$scope.selected = {};
		$scope.selected.factories = [];
		$scope.user = {};
		$scope.user.base = {};
		$scope.user.factory = {};
		$scope.user.customer = {};
		$scope.customerName = globalConfig.customer.name;
		$scope.customerId = globalConfig.customer.id;
		$scope.isCustomerAdmin = $rootScope.authz.isCustomerAdmin();
		$scope.isSuperAdmin = $rootScope.authz.isSuperAdmin();
		$scope.updateSitesByCustomer = updateSitesByCustomer;
		$scope.updateDataBySite = updateDataBySite;
		$scope.setSuperSystemAdministratorValues = setSuperSystemAdministratorValues;
		$scope.setCustomerAdministratorValues = setCustomerAdministratorValues;

		var emailSuffixes;

		init();

		function init() {
			$scope.totalCustomers = siteService.getCustomersCount();
			if ($scope.totalCustomers > 1) {
				getCustomersDropdownList();
			} else {
				$scope.user.factory['customerId'] = globalConfig.customer.id;
				$scope.sites = siteService.getUserSites();
				getEmailSuffixes(true);
			}
			$scope.hasMultipleSites = $scope.isCustomerAdmin || $scope.totalCustomers > 1 || $scope.sites.length > 1;
			if (!$scope.hasMultipleSites) {
				$scope.user.factory.ids = [globalConfig.factory.id];
			}
			loadStaticData();
			initFormWithDefaults();
		}

		function getEmailSuffixes(doLoadData) {
			var ids = $scope.user.factory.ids ? $scope.user.factory.ids : [globalConfig.factory.id];
			emailSuffixes = _.uniq(_.map(_.filter(globalConfig.user.authFacts, function (fact, factoryNdx) {
				return $scope.user.customer.isCustomerAdministrator ? fact.customerNdx === $scope.customerId : ids.indexOf(+factoryNdx) > -1;
			}), function (fact) {
				return fact.emailSuffix;
			}));
			if (doLoadData && ids.length) {
				getData(ids);
			}
		}

		function updateSitesByCustomer($customer) {
			$scope.customerName = $customer.name;
			$scope.customerId = $customer.ndx;
			$scope.sites = siteService.getAdminSitesByCustomer($customer.ndx);
			$scope.user.factory.ids = $scope.user.customer.isCustomerAdministrator ? [$scope.sites[0].id]: undefined;
		}

		function updateDataBySite() {
			$scope.suppliers = [];
			$scope.user.factory.supplier = undefined;
			$scope.permissions = [];
			$scope.mandatoryFilters = [];
			getEmailSuffixes(true);
		}

		function getCustomersDropdownList() {
			navigationService.getCustomersForUser().then(function (data) {
				if (data && data.length) {
					$scope.customers = data;
				}
			});
		}

		function loadStaticData() {
			userManagementService.getRoles(true).then(function initRoles(roles) {
				$scope.roles = roles;
			});
			userManagementService.getProfileTypes().then(function initPrivileges(types) {
				$scope.privileges = types;
			});
		}

		function getData(factoryIds, loadStaticData) {
			initFormWithDefaults();
			userManagementService.getRoles(true).then(function initRoles(roles) {
				$scope.roles = roles;
			});
			userManagementService.getCrossSiteSuppliers(factoryIds.join(',')).then(function initSuppliers(suppliers) {
				$scope.suppliers = suppliers;
			});
			userManagementService.getPermissions(factoryIds[0]).then(function (data) {
				$scope.permissions = data;
			});
			userManagementService.getMandatoryFilters(factoryIds[0]).then(function (data) {
				$scope.mandatoryFilters = data;
			});
			// Enable lean only for JR Automation and Aspen Aerogels
			$scope.user.customer.isLeanOnly = $scope.customerId === 14 || $scope.customerId === 149;
		}

		function initFormWithDefaults() {
			$scope.user.base.isSingleSignOn = true;
			$scope.user.base.isComputerActivationEnabled = true;
			$scope.user.base.isSuperSystemAdministrator = false;
			$scope.user.customer.isLeanOnly = false;
			$scope.user.customer.isCustomerAdministrator = false;
			$scope.user.customer.canCreateSupplierUser = false;
			$scope.user.customer.canAccessIOP = false;
			$scope.user.customer.canAccessKei = false;
			$scope.user.base.isUSPerson = false;
			$scope.user.factory.profileType = 'ReadWriteUser';
			$scope.user.factory.homePageObj = {
				isActive: true,
				name: 'Dashboard',
				forSupplier: false,
				uri: 'f/home.html#/'
			};
			$scope.user.factory.authorizeLeanInitiativeFlag = false;
			$scope.user.factory.isFinancialApprover = false;
			$scope.user.factory.isSmeCertified = false;
			$scope.user.factory.isWorkbenchSupervisor = false;
			$scope.user.factory.canEditAnyMetric = false;
			$scope.user.factory.canEditAnyMetricTargets = false;
			$scope.user.factory.roleType = undefined;
			$scope.user.base.activatedFlag = true;
			$scope.user.base.userTrainingLogonFlag = false;
			$scope.user.factory.emailType = 'Immediate';
			$scope.user.factory.isVirtualProfile = false;
			$scope.pageLoaded = true;
		}

		function setSuperSystemAdministratorValues($isSuperSystemAdministrator) {
			if ($isSuperSystemAdministrator.value) {
				$scope.user.factory.ids = [globalConfig.factory.id];
				$scope.user.factory.profileType = 'SuperSystemAdministrator';
				$scope.user.factory.homePageObj = {
					isActive: true,
					name: 'Dashboard',
					forSupplier: false,
					uri: 'f/home.html#/'
				};
				$scope.user.factory.authorizeLeanInitiativeFlag = false;
				$scope.user.factory.isFinancialApprover = false;
				$scope.user.factory.isSmeCertified = false;
				$scope.user.factory.isWorkbenchSupervisor = false;
				$scope.user.factory.canEditAnyMetric = false;
				$scope.user.factory.canEditAnyMetricTargets = false;
				$scope.user.factory.roleType = 'LeanDNAStaff';
				$scope.user.base.activatedFlag = true;
				$scope.user.base.userTrainingLogonFlag = false;
				$scope.user.factory.emailType = 'Off';
				$scope.user.factory.hideFromUserDropdown = true;
				$scope.user.factory.isVirtualProfile = false;
				$scope.user.customer.canCreateSupplierUser = false;
				$scope.user.customer.canAccessIOP = false;
				$scope.user.customer.canAccessKei = false;
			} else {
				initFormWithDefaults();
			}
		}

		function setCustomerAdministratorValues($isCustomerAdministrator) {
			if ($isCustomerAdministrator.value) {
				$scope.user.base.isSuperSystemAdministrator = false;
				$scope.user.factory.profileType = 'SystemAdministrator';
				$scope.user.factory.authorizeLeanInitiativeFlag = false;
				$scope.user.factory.isFinancialApprover = false;
				$scope.user.factory.isSmeCertified = false;
				$scope.user.factory.isWorkbenchSupervisor = false;
				$scope.user.factory.canEditAnyMetric = false;
				$scope.user.factory.canEditAnyMetricTargets = false;
				$scope.user.base.activatedFlag = true;
				$scope.user.base.userTrainingLogonFlag = false;
				$scope.user.factory.isVirtualProfile = false;
				$scope.user.customer.canCreateSupplierUser = false;
				$scope.user.customer.canAccessIOP = false;
				$scope.user.customer.canAccessKei = false;
			} else {
				initFormWithDefaults();
			}
		}

		function clearToast() {
			$scope.toastMessage = undefined;
		}

		function clearErrorMessage() {
			$scope.errorMessage = '';
		}

		function cancel() {
			location.href = '/application/f/home.html#/setup/manage-users';
		}

		$scope.$watch(validForm, function (formIsValid) {
			$scope.formIsValid = formIsValid;
		});

		$scope.ssoAvailableForUser = function() {
			return globalConfig.factory.hasSingleSignOn &&
				$scope.user.base.emailAddress &&
				$scope.user.base.emailAddress.endsWith(globalConfig.factory.emailSuffix);
		};

		$scope.hideSitePicker = function () {
			return $scope.user.base.isSuperSystemAdministrator || $scope.user.customer.isCustomerAdministrator || !$scope.hasMultipleSites;
		};

		function validForm() {
			if (
				$scope.user.base.firstName !== undefined &&
				$scope.user.base.lastName !== undefined &&
				$scope.user.base.emailAddress !== undefined &&
				$scope.emailPattern.test($scope.user.base.emailAddress) &&
				$scope.user.factory.homePageObj !== undefined &&
				$scope.user.factory.profileType !== undefined &&
				$scope.user.factory.roleType !== undefined &&
				$scope.user.factory.authorizeLeanInitiativeFlag !== undefined &&
				$scope.user.factory.isFinancialApprover !== undefined &&
				(!$scope.displayHideFromDropdown || $scope.user.factory.hideFromUserDropdown !== undefined) &&
				($scope.user.factory.roleType !== 'Supplier' || $scope.user.factory.supplier !== undefined) &&
				$scope.user.base.isSuperSystemAdministrator !== undefined &&
				$scope.user.customer.isCustomerAdministrator !== undefined &&
				$scope.user.factory.ids !== undefined &&
				($scope.user.base.emailAddress && $scope.user.base.emailAddress.toLowerCase().endsWith('@leandna.com') || !$scope.user.base.isSuperSystemAdministrator) &&
				(!$scope.user.base.isSuperSystemAdministrator || $scope.user.base.isUSPerson)
			) {
				return true;
			} else {
				return false;
			}
		}

		function postToServer() {
			$scope.user.base.emailAddress = $scope.user.base.emailAddress.trim();
			$scope.user.base.username = $scope.user.base.emailAddress;
			$scope.user.base.firstName = $scope.user.base.firstName.trim();
			$scope.user.base.lastName = $scope.user.base.lastName.trim();
			$scope.user.factory.homePage = $scope.user.factory.homePageObj.uri;
			$scope.user.factory.homePageName = $scope.user.factory.homePageObj.name;
			$scope.user.customer.emailType = $scope.user.factory.emailType;
			$scope.user.customer.roleType = $scope.user.factory.roleType;
			$scope.user.customer.hideFromUserDropdown = $scope.user.factory.hideFromUserDropdown || false;
			$scope.user.customer.homePage = $scope.user.factory.homePage;
			$scope.user.customer.homePageName = $scope.user.factory.homePageName;
			$scope.user.customer.customerNdx = $scope.customerId;
			if ($scope.user.factory.roleType === 'Supplier')
				$scope.user.factory.supplierCode = $scope.user.factory.supplier.supplierCode;
			else
				$scope.user.factory.supplierCode = null;
			if ($scope.user.factory.permissionsObj && $scope.user.factory.permissionsObj.ndx)
				$scope.user.factory.permissions = $scope.user.factory.permissionsObj.ndx;
			else
				$scope.user.factory.permissions = null;
			if ($scope.user.factory.mandatoryFiltersObj && $scope.user.factory.mandatoryFiltersObj.length) {
				var mf = '';
				for (var i = 0; i < $scope.user.factory.mandatoryFiltersObj.length; i++) {
					if (i != 0) mf += ',';
					mf += $scope.user.factory.mandatoryFiltersObj[i].ndx;
				}
				$scope.user.factory.mandatoryFilters = mf;
			}
			if (!$scope.displayHideFromDropdown) {
				$scope.user.factory.hideFromUserDropdown = false;
			}
			userManagementService.addUser($scope.user).then(handleResponse);
		}

		function emailSuffixConfirmed() {
			postToServer();
		}

		function submit() {
			getEmailSuffixes(false);
			var suffixMatches = _.some(emailSuffixes, function (suffix) {
				return $scope.user.base.emailAddress.toLowerCase().endsWith(suffix.toLowerCase());
			});
			if (!suffixMatches && !$scope.user.base.emailAddress.toLowerCase().endsWith(LEANDNA_EMAIL_SUFFIX)) {
				emailSuffixConfirmationForm();
			} else {
				postToServer();
			}
		}

		function handleResponse(response) {
			if (response === null) {
				$timeout(function () {
					location.href = '/application/f/home.html#/setup/manage-users?message=User%20created%20successfully';
				}, 0);
			} else {
				$scope.errorMessage = response.data.error;
				$timeout(function () {
					$scope.errorMessage = '';
				}, 5000);
			}
		}

		function roleSelected($item, $model) {
			if ($item.roleType === 'Supplier') {
				$scope.user.factory.profileType = 'ReadWriteUser';
				$scope.user.factory.authorizeLeanInitiativeFlag = false;
			}
		}

		$scope.filterRoles = function filterRoles(role) {
			// hide supplier role if creating customer admin
			return !(role.roleType == 'Supplier' && $scope.user.customer.isCustomerAdministrator);
		};

		function emailSuffixConfirmationForm() {
			var emailSuffixConfirmationScope = $scope.$new();
			emailSuffixConfirmationScope.userEmailAddress = $scope.user.base.emailAddress;
			emailSuffixConfirmationScope.factoryEmailSuffixes = emailSuffixes.join(', ');
			emailSuffixConfirmationScope.hasMultipleCustomers = $scope.totalCustomers > 1;
			emailSuffixConfirmationScope.selected = { 'customer': undefined };
			emailSuffixConfirmationScope.preventPaste = function (ev) {
				ev.preventDefault();
			};
			emailSuffixConfirmationScope.submitSuffixForm = function () {
				if ($scope.totalCustomers > 1) {
					// Check if the user entered customer name equals to selected customer name
					if ($scope.customerName.toLowerCase() === emailSuffixConfirmationScope.selected.customer.toLowerCase()) {
						emailSuffixConfirmed();
					} else {
						$rootScope.$emit('toast', {
							'message': 'The entered customer does not match the selected customer name',
							'success': false
						});
					}
				} else {
					emailSuffixConfirmed();
				}
			};

			var opts = {
				scope: emailSuffixConfirmationScope,
				templateUrl: '/application/f/setup/email_suffix_confirmation.html'
			};

			var emailConfirmationInstance = $uibModal.open(opts);
			emailSuffixConfirmationScope.closeDialog = function () {
				emailConfirmationInstance.close();
				emailSuffixConfirmationScope.$destroy();
			};
		}
	});
